import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'pages',
  children: {
    list: {
      path: 'list',
    },
    page: {
      path: ':pageId',
    },
  },
} as const satisfies Location
